import { memo, useContext, useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MachineForm from './components/MachineForm';
import { useTranslation } from 'react-i18next';
import MachineOrders from './components/MachineOrders';
import GeneralData from './components/GeneralData';
import Attachments from './components/Attachments';
import { TabContext } from '../../../Context/TabContext';
import { formatDateBody } from '../../../../utils/FormatDate';
import useHttp from '../../../hooks/use-http';
import { urls } from './api/urls';
import MuiDialog from '../../UI/MuiDialog/MuiDialog';

const INITIAL_MACHINE_VALUE = {
  idMasine: 0,
  nazivMasine: '',
  sifra: '',
  nazivTipaMasine: '',
};
const INITIAL_CONTACT_VALUE = {
  kontaktOsoba: 'Demo',
  telefon: '(555) 123-6789',
  email: 'demo123@example.com',
};
const INITIAL_GENERAL_DATA = {
  idDok: 0,
  naslov: '',
  vrsteKvarova: '',
  idVrsteKvarova: 0,
  kodGreske: '',
  brojSatiRada: '',
  spindleHours: '',
  opisProblema: '',
  idStatusaMasine: 0,
  statusMasine: '',
  listaVrstaKvarova: [],
};

const ZahtevZaServisInmold = ({ handleNoviRadniNalog, noviRadniNalog }) => {
  const { getData } = useHttp('');
  const { t, i18n } = useTranslation();
  // #region[color2] ===== Prosledjivanje podataka sa druge stranice =====
  const { tabsData, activeComponent, addTab } = useContext(TabContext);
  const dataLocal = tabsData.find((item) => item.type === activeComponent);
  const machineLocal = dataLocal?.data ? dataLocal?.data : {};
  const [machineValue, setMachineValue] = useState(INITIAL_MACHINE_VALUE);
  // #endregion
  const [contactValue, setContactValue] = useState(INITIAL_CONTACT_VALUE);
  const [machineData] = useState([]);
  const [generalValue, setGeneralValue] = useState(INITIAL_GENERAL_DATA);
  const [attachmentData, setAttachmentData] = useState([]);
  const [machineForm, setMachineForm] = useState({});
  const [servisiData, setServisiData] = useState([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const setZahtevToRead = async (id = machineLocal.id) => {
    const config = {
      url: urls.SET_READ,
      method: 'POST',
      data: {
        Id: id,
        idKorProm: +localStorage.getItem('idKorisnika'),
      },
    };
    const response = await getData(config);
  };

  const getEditData = async (id) => {
    // console.log(id);
    const config = {
      method: 'POST',
      url: urls.GET_ZAHTEVE_ZA_ID,
      data: {
        id: id,
        metadata: i18n.language,
      },
    };
    const response = await getData(config);
    // console.log('Zahtevi za id', response);
    if (response.id > 0) {
      setGeneralValue(response);
      setMachineValue({
        idMasine: response.idMasine,
        nazivMasine: response.nazivMasine,
        sifra: response.sifra,
        nazivTipaMasine: response.nazivTipaMasine,
      });
      const listaFajlova = response?.listaDokumenata.map((item) => {
        return { ...item, name: item.vrednost };
      });
      setAttachmentData(listaFajlova);
      if (
        machineLocal.notifikacija &&
        localStorage.getItem('idFirme') === '1' &&
        !response.procitano
      ) {
        setZahtevToRead(response.id);
      }
    }
  };
  useEffect(() => {
    // console.log('novi radni nalog', noviRadniNalog);
    if (noviRadniNalog) {
      const tab = {
        title: 'Radni nalog',
        icon: 'fas fa-clipboard',
        type: 10012,
        data: { prenetiIdServisnogZahteva: machineLocal.idDok },
      };
      addTab(tab);
      handleNoviRadniNalog(false);
    }
  }, [noviRadniNalog]);

  useEffect(() => {
    if (
      localStorage.getItem('idFirme') === '1' &&
      !machineLocal.procitano &&
      !machineLocal.notifikacija
    ) {
      setZahtevToRead();
    }
  }, []);

  // setovanje podataka masine sa druge strane
  useEffect(() => {
    // console.log('podaci sa kartice masine', machineLocal);
    setMachineForm(machineLocal);

    // setMachineValue({
    //   idMasine: machineLocal.idMasine,
    //   nazivMasine: machineLocal.nazivMasine,
    // });
    // setContactValue({
    //   kontaktOsoba: machineLocal.kontaktOsoba,
    //   telefon: machineLocal.kontaktTelefon,
    //   email: machineLocal.email,
    // });
    getEditData(machineLocal.idDok);
  }, [i18n.language, machineLocal.idDok]);

  // #region [color4] grid za prikaz zahteva
  const vratiServiseZaMasinu = async () => {
    const config = {
      url: urls.GET_ZAHTEVE_ZA_MASINU,
      method: 'POST',
      data: {
        Id: machineForm.idMasine,
        metadata: i18n.language,
      },
    };
    const response = await getData(config);
    setServisiData(response);
  };
  useEffect(() => {
    if (machineForm.idMasine !== 0) {
      vratiServiseZaMasinu();
    }
  }, [machineForm.idMasine, i18n.language]);

  // #endregion

  // #region [color3] ===== Accordion ===
  const [panels, setPanels] = useState([
    // zaglavlje
    // {
    //   id: 'machine',
    //   title: 'machine',
    //   expanded: true,
    //   component: memo(MachineForm),
    // },
    // Opsti podaci forma
    {
      id: 'generalData',
      title: 'generalData',
      expanded: true,
      component: memo(GeneralData),
    },
    // kacenje dokumenta
    {
      id: 'attachments',
      title: 'attachments',
      expanded: true,
      component: memo(Attachments),
    },
    // grid za prikaz zahteva
    // {
    //   id: 'machineOrders',
    //   title: 'openOrdersForMachine',
    //   expanded: false,
    //   component: memo(MachineOrders),
    // },
  ]);

  const handleChangeExpand = (index) => {
    setPanels((prevPanels) =>
      prevPanels.map((panel, i) =>
        i === index ? { ...panel, expanded: !panel.expanded } : panel,
      ),
    );
  };
  // #endregion
  return (
    <div>
      {panels.map((panel, index) => (
        <Accordion
          key={panel.id}
          expanded={panel.expanded}
          onChange={() => handleChangeExpand(index)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel${index + 1}-content`}
            id={`panel${index + 1}-header`}
          >
            <strong>{t(panel.title)}</strong>
          </AccordionSummary>
          <AccordionDetails>
            {/* {index === 0 && (
              <panel.component
                machineValue={machineValue}
                setMachineValue={setMachineValue}
                machineData={machineData}
                contactValue={contactValue}
                generalValue={generalValue}
              />
            )} */}

            {index === 0 && (
              <panel.component
                machineValue={machineValue}
                generalValue={generalValue}
                setGeneralValue={setGeneralValue}
                tipId={
                  machineForm?.idTipaMasine > 0 ? machineForm?.idTipaMasine : 0
                }
              />
            )}
            {index === 1 && (
              <panel.component
                setAttachmentData={setAttachmentData}
                attachmentData={attachmentData}
              />
            )}
            {/* {index === 2 && (
              <panel.component
                data={servisiData}
                getEditData={getEditData}
                // handleOpenDeleteDialog={handleOpenDeleteDialog}
              />
            )} */}
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default ZahtevZaServisInmold;
